const backendUrl = process.env.REACT_APP_BACKEND_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:5001' : 'https://safacards.onrender.com');
 
export { backendUrl }; 